let scopedPresentationId = null
let latestRequestId = 0
let pendingLoad = null

export const getScopedPresentationId = () => scopedPresentationId

export const isPlanBenefitScopedToPresentation = () => scopedPresentationId !== null

export const nextScopeRequest = (presentationId) => {
  scopedPresentationId = presentationId || null
  latestRequestId += 1
  return latestRequestId
}

export const isLatestScopeRequest = (requestId) => requestId === latestRequestId

export const getPendingLoad = () => pendingLoad

export const setPendingLoad = (promise) => {
  pendingLoad = promise
}

let holderCount = 0

export const addHolder = () => {
  holderCount += 1
}

export const removeHolder = () => {
  holderCount = Math.max(0, holderCount - 1)
  return holderCount
}
